import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Depotfinder from "./views/Depotfinder.vue";
import Decision from "./views/depotfinder/Decision.vue";
import Age from "./views/depotfinder/Age.vue";
import Orders from "./views/depotfinder/Orders.vue";
import Assets from "./views/depotfinder/Assets.vue";
import Services from "./views/depotfinder/Services.vue";
import Results from "./views/depotfinder/Results.vue";

import store from "./store";

Vue.use(Router);

let routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: { bodyClass: "home" }
  },
  {
    path: "/depotfinder",
    name: "depotfinder",
    component: Depotfinder,
    meta: {
      bodyClass: "depotfinder",
      appClass: "depotfinder"
    },
    redirect: { name: "depotfinder.decision" },
    children: [
      {
        path: "/depotfinder/decision",
        name: "depotfinder.decision",
        component: Decision,
        meta: {
          bodyClass: "depotfinder-decision",
          appClass: "depotfinder depotfinder-decision"
        }
      },
      {
        path: "/depotfinder/age",
        name: "depotfinder.age",
        component: Age,
        meta: {
          bodyClass: "depotfinder-age",
          appClass: "depotfinder depotfinder-age"
        }
      },
      {
        path: "/depotfinder/orders",
        name: "depotfinder.orders",
        component: Orders,
        meta: {
          bodyClass: "depotfinder-orders",
          appClass: "depotfinder depotfinder-orders"
        }
      },
      {
        path: "/depotfinder/assets",
        name: "depotfinder.assets",
        component: Assets,
        meta: {
          bodyClass: "depotfinder-assets",
          appClass: "depotfinder depotfinder-assets"
        }
      },
      {
        path: "/depotfinder/services",
        name: "depotfinder.services",
        component: Services,
        meta: {
          bodyClass: "depotfinder-services",
          appClass: "depotfinder depotfinder-services"
        }
      },
      {
        path: "/depotfinder/results",
        name: "depotfinder.results",
        component: Results,
        meta: {
          bodyClass: "depotfinder-results",
          appClass: "depotfinder depotfinder-results"
        }
      }
    ]
  }
];

const router = new Router({
  routes
});

// Route Guard > close all open overlays when route changes that could break views
router.beforeEach((to, from, next) => {
  if (from != null) {
    // Close overlayBG
    if (store.getters.getOverlayBGState) {
      store.dispatch("updateView", {
        view: "overlayBG",
        payload: false
      });
    }

    // Close ChangeTarrif
    if (store.getters.getChangeTarrifViewState) {
      store.dispatch("updateView", {
        view: "changeTarrifView",
        payload: false
      });
    }

    // Close RequestInformation
    if (store.getters.getInformationViewState) {
      store.dispatch("updateView", {
        view: "informationView",
        payload: false
      });
    }
  }
  next();
});

export default router;
